<template>
  <div>
    <b-row>
      <b-col md="5"><h3>Customer Management</h3></b-col>
      <b-col md="3">
        <eb-select
          type="select"
          v-model="selected"
          :options="options"
          label="text"
          id="value"
          placeholder="Search Type"
        ></eb-select>
      </b-col>
      <b-col md="4">
        <Vue-Simple-Suggest
          :nullable-select="true"
          v-model="searchInput"
          @keyup.enter.native="searchResult()"
          :debounce="1000"
          display-attribute="name"
          value-attribute="_id"
          placeholder="Search Customer"
        ></Vue-Simple-Suggest>
        <button class="text-grey searchIcon" @click="searchResult()">
          <i class="fa fa-search mt-2" aria-hidden="true"></i>
        </button>
        <b-modal
          title="Select Customer"
          id="SimilarName"
          size="lg"
          ref="select-customer-name"
          centered
          hide-footer
        >
          <b-row
            class="m-1 modalOption"
            v-for="(customer, index) in this.similarNameData"
            :key="index"
            :id="`customer${index}`"
            @click="selectedCustomer(index)"
          >
            <b-col md="4">
              <h5>Full Name:</h5>
              <span style="word-wrap: break-word"
                >{{ customer && customer.name ? customer.name.first : "" }}
                {{ customer && customer.name ? customer.name.last : "" }}</span
              >
            </b-col>
            <b-col md="4">
              <h5>Email:</h5>
              <span style="word-wrap: break-word">{{
                customer && customer.authentication
                  ? customer.authentication.email
                  : ""
              }}</span>
            </b-col>
            <b-col md="4">
              <h5>Phone:</h5>
              <span>{{
                customer && customer.authentication
                  ? customer.authentication.phone
                  : ""
              }}</span>
            </b-col>
          </b-row>
        </b-modal>
      </b-col>
    </b-row>
    <b-card style="height: 500px">
      <img
        :src="`img/customerCare.png`"
        style="margin-left: 260px; height: 340px; margin-top: 60px"
      />
    </b-card>
  </div>
</template>

<script>
import cInput from "@/components/Common/CustomInput";
import ebSelect from "@/components/FormElements/Select.vue";
import ebButton from "@/components/FormElements/Button";
import VueSimpleSuggest from "vue-simple-suggest";
import "vue-simple-suggest/dist/styles.css";

export default {
  components: {
    ebButton,
    cInput,
    VueSimpleSuggest,
    ebSelect,
  },
  data() {
    return {
      searchInput: "",
      selected: "",
      options: [
        { text: "Search Type", value: "", disabled: true },
        { text: "Customer Number", value: "CUSTOMERNO" },
        { text: "Service Ticket", value: "SR" },
        { text: "Order Number", value: "ORDERNO" },
        { text: "Name", value: "" },
        { text: "Mobile Number", value: "" },
        { text: "E-mail Id", value: "" },
      ],
      similarNameData: "",
    };
  },
  methods: {
    searchResult() {
      const payload = {
        type: this.selected.value,
        keyword: this.searchInput,
      };
      this.$store
        .dispatch("customerManagement/customerByFilter", payload)
        .then((payload) => {
          const paramsData = payload.data?.response || "";
          if (paramsData.length == 0) {
            throw Error("Invalid data");
          }
          if (paramsData.length > 1) {
            this.similarNameData = paramsData;
            this.$refs["select-customer-name"].show();
          } else {
            this.$router.push({
              name: "Customer-Management-Listing",
              params: { userData: paramsData, id: paramsData._id },
            });
          }
        })
        .catch((err) => {
          this.$swal({
            title: "Opps!!!!!",
            text: "Please Enter a valid data ",
            type: "error",
          });
        });
    },
    selectedCustomer(index) {
      this.$router.push({
        name: "Customer-Management-Listing",
        params: {
          userData: this.similarNameData[index],
          id: this.similarNameData[index]?._id || "",
        },
      });
    },
  },
};
</script>

<style>
.text-grey {
  color: #aaaa;
  background-color: transparent;
}

.modalOption {
  text-align: center;
  border: 1px solid #e0dfdf;
  border-radius: 10px;
}
.modalOption:hover {
  cursor: pointer;
  background-color: #f2f2f2;
}

.vue-simple-suggest.designed .input-wrapper input {
  display: block;
  width: 100% !important;
  padding: 10px;
  border: 1px solid #cde;
  border-radius: 25px !important;
  color: black;
  background: white;
  outline: none;
  transition: all 0.1s;
  transition-delay: 0.05s;
}
</style>
